import React from 'react';

import {useAdditionalSeedData} from 'pageflow-scrolled/frontend';
import {DefaultNavigation} from 'pageflow-scrolled/widgets/defaultNavigation';

import 'pageflow-scrolled/widgets/defaultNavigation.css';

import {SubscriptionButtons} from './SubscriptionButtons';
import {MobileMenu} from './MobileMenu';

export function Navigation(props) {
  const {appMode} = useAdditionalSeedData('handelsblatt');

  if (appMode) {
    return null;
  }

  return (
    <DefaultNavigation {...props}
                       ExtraButtons={SubscriptionButtons}
                       MobileMenu={MobileMenu} />
  );
}
